import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-items-sowhatbuy';

const html = `
<div data-attribute="wrap-card" class="container wrap-card">
  <div data-attribute="card-title" class="card-title" data-show="true">
    <h2 style="text-align:center;">Tired <span style="color:#e64c4c;">Of Blurry Small Print?</span></h2>
    <p style="text-align:center;">Tired of straining your eyes with traditional screens? Switch to glare-free,
      eye-friendly viewing.</p>
  </div>
  <div data-attribute="list-item" class="wrap-list-item">
    <div data-attribute="item" class="item">
      <div class="wrap-image-item">
        <img data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ea07303ac9d66196f849.jpg" alt="">
      </div>
      <div data-attribute="info-item" class="info-item">
        <p>Blurry Print</p>
      </div>
    </div>
    <div data-attribute="item" class="item">
      <div class="wrap-image-item">
        <img data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ea07303ac9d66196f849.jpg" alt="">
      </div>
      <div data-attribute="info-item" class="info-item">
        <p>Blurry Print</p>
      </div>
    </div>
    <div data-attribute="item" class="item">
      <div class="wrap-image-item">
        <img data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ea07303ac9d66196f849.jpg" alt="">
      </div>
      <div data-attribute="info-item" class="info-item">
        <p>Blurry Print</p>
      </div>
    </div>
    <div data-attribute="item" class="item">
      <div class="wrap-image-item">
        <img data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ea07303ac9d66196f849.jpg" alt="">
      </div>
      <div data-attribute="info-item" class="info-item">
        <p>Blurry Print</p>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
